export default function getResource(label, vars = []) {
    const resources = {
        beautyTraits: 'Beauty Traits',
        beautyTraitsInclude: 'Beauty Traits on your profile include:',
        beautyPreferences: 'Beauty Preferences',
        beautyPreferencesInclude: 'Beauty Preferences on your profile include:',
        skinType: 'Skin type',
        skinTone: 'Skin tone',
        skinConcerns: 'Skin concerns',
        ingredientPreferences: 'Ingredient preferences',
        fragranceFamily: 'Fragrance family',
        hairType: 'Hair type',
        hairTexture: 'Hair texture',
        hairConcerns: 'Hair concerns',
        hairColor: 'Hair color',
        shoppingPreferences: 'Shopping preferences',
        favoriteBrands: 'Favorite brands',
        eyeColor: 'Eye color',
        colorIQ: 'Color IQ',
        beautyTraitsVisible: 'Beauty Traits on your profile are visible to:',
        beautyPreferencesVisible: 'Beauty Preferences on your profile are visible to:',
        everyone: 'Everyone',
        justMe: 'Just me',
        profile: 'Profile',
        yourProfileVisibleMe: 'Your Profile is visible to: Just me',
        yourProfileVisibleEveryone: 'Your Profile is visible to: Everyone',
        yourSkincareConcerns: 'Your skin and hair concerns are always hidden from your Community profile. Fellow shoppers who match your beauty preferences will see your traits when you post a review.',
        yourBeautyInsider: 'Your Beauty Insider, Lists and Account pages are always private.',
        forMoreInformation: 'For more information, see our',
        privacyPolicy: 'Privacy Policy',
        and: 'and',
        termsOfUse: 'Terms of Use'
    };
    return resources[label];
}
